import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useBreadcrumb } from "../shell/ContextHeader";

// §10.1: Workspace is the landing surface - my active assessments, reviews
// waiting for me, overdue actions, recently published reports. None of those
// exist before runs do, so this is the designed first-use empty state (§11),
// not a placeholder: it says what will appear and offers the one action a new
// user can take.

export function Workspace() {
  const { setTrail } = useBreadcrumb();
  useEffect(() => setTrail([{ label: "Workspace" }]), [setTrail]);

  return (
    <>
      <h1>Workspace</h1>
      <div className="card empty-state">
        <h3>Nothing needs your attention yet</h3>
        <p>
          Active assessments, reviews waiting for you, overdue actions and
          recently published reports will appear here as they happen.
        </p>
        <p>
          Start from <Link to="/clients">Clients &amp; engagements</Link> — set
          up an assessed entity and an engagement, then create an assessment
          run against it.
        </p>
      </div>
    </>
  );
}
